import { CartAddEvent } from '@theme/events';

const root = () => window.Shopify?.routes?.root || '/';
class SauveCartRecommendations extends HTMLElement {
  static observedAttributes = ['data-rec-product-id', 'data-cart-products'];
  connectedCallback() {
    this.refresh = () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.load(), 220); };
    document.addEventListener('cart:update', this.refresh);
    this.observer = new MutationObserver(() => {
      if (!this.loading && this.hadCards && !this.querySelector('.sauve-crec')) this.refresh();
    });
    this.observer.observe(this, { childList: true });
    this.refresh();
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    this.controller?.abort();
    this.observer?.disconnect();
    document.removeEventListener('cart:update', this.refresh);
  }
  attributeChangedCallback() { if (this.isConnected) this.refresh?.(); }
  async load() {
    if (!this.dataset.recProductId) return;
    this.controller?.abort();
    const controller = new AbortController();
    this.controller = controller;
    this.loading = true;
    try {
      let result;
      for (const intent of ['complementary', 'related']) {
        const params = new URLSearchParams({ section_id: 'sauve-cart-recs', product_id: this.dataset.recProductId, intent, limit: '10' });
        const response = await fetch(`${root()}recommendations/products?${params}`, { signal: controller.signal });
        if (!response.ok) throw new Error('Recommendations unavailable');
        result = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.sauve-crec');
        if (result?.querySelector('.sauve-crec__card')) break;
      }
      if (!this.isConnected || controller.signal.aborted) return;
      this.hadCards = !!result?.querySelector('.sauve-crec__card');
      this.replaceChildren(...(this.hadCards ? [result] : []));
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.hadCards = false;
        this.replaceChildren();
      }
    } finally { if (this.controller === controller) this.loading = false; }
  }
}
if (!customElements.get('sauve-cart-recommendations')) customElements.define('sauve-cart-recommendations', SauveCartRecommendations);

let pending = false;
document.addEventListener('click', async event => {
  const button = event.target.closest?.('.sauve-crec__add[data-variant-id]');
  if (!button) return;
  event.preventDefault();
  if (pending || button.disabled) return;
  pending = true;
  const buttons = [...document.querySelectorAll('.sauve-crec__add')];
  buttons.forEach(b => { b.disabled = true; });
  button.textContent = 'Agregando…';
  const container = button.closest('.sauve-crec');
  const errorBox = container.querySelector('[data-rec-error]');
  errorBox.hidden = true;
  let confirmedFailure = false;
  let completed = false;
  try {
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))];
    const variantId = button.dataset.variantId;
    const response = await fetch(`${root()}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections, sections_url: location.pathname })
    });
    if (!response.ok) {
      confirmedFailure = response.status >= 400 && response.status < 500;
      throw new Error('Cart addition failed');
    }
    const data = await response.json();
    const added = data.items?.find(item => String(item.variant_id || item.id) === variantId);
    if (!added) throw new Error('Missing added item');
    const cartResponse = await fetch(`${root()}cart.js`);
    if (!cartResponse.ok) throw new Error('Cart verification unavailable');
    const cart = await cartResponse.json();
    if (!cart.items.some(item => String(item.variant_id) === variantId)) throw new Error('Cart addition unconfirmed');
    completed = true;
    document.dispatchEvent(new CartAddEvent(added, 'sauve-cart-recs', {
      source: 'sauve-cart-recs', itemCount: cart.item_count, sections: data.sections,
      productId: String(added.product_id), variantId
    }));
  } catch (error) {
    const text = errorBox.querySelector('[data-rec-error-message]');
    text.textContent = confirmedFailure
      ? 'No pudimos agregar esta pieza. Revisa su disponibilidad o intenta de nuevo.'
      : 'No pudimos confirmar el resultado. Revisa tu carrito antes de volver a agregar la pieza.';
    errorBox.hidden = false;
  } finally {
    pending = false;
    buttons.forEach(b => { if (b.isConnected) b.disabled = b === button && !confirmedFailure; });
    if (button.isConnected) button.textContent = completed ? 'Agregada' : confirmedFailure ? 'Reintentar' : 'Revisa el carrito';
  }
});
